import { FlatCommission } from '../FlatCommission/types';

export interface AdjustmentToCommission {
  condition: AdjustmentCommissionType;
  adjustedCommissionRate?: FlatCommission;
}

export enum AdjustmentCommissionType {
  NoAdjustment = 'NoAdjustment',
  YesAdjustment = 'YesAdjustment',
}
